export default "dır-dir\nveya\nNeresi\nNe\nNasıl\nkaç tane\nNe kadar\nmeli\nolabilmek"